import { Controller } from 'stimulus'


export default class extends Controller {

    initialize() {
    }

    connect () {

        let options = {
            root: null,
            rootMargin: "0px 0px 0px 0px",
            threshold: 0
        }

        document.querySelector('.project-logo').classList.add('js-hidden')
        
        this.observer = new IntersectionObserver((entries) => {
            const ratio = entries[0].intersectionRatio;

            const logo = document.querySelector('.project-logo')

            if (logo) {

                if (ratio === 0) {
                    logo.classList.remove('js-hidden')
                }

                if (ratio !== 0) {
                    logo.classList.add('js-hidden') 
                }
            }
        }, options);
        
        const element = document.querySelector('.trigger-logo')
        this.observer.observe(element);
    }

    disconnect () {
    }

  }